import React from 'react';
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`;

const ClientDetails = ({ SelectedBrief }) => {
    return (
        <div className='BriefClientDetails'>
            <div className='clientProfileSection'>
                <div className='clientProfileSect'>
                    <img src={UserIcon} alt='User icon' />
                </div>
                <div className='clientDetails'>
                    {typeof (SelectedBrief.client) === 'object' && SelectedBrief.client !==null && SelectedBrief.client !==undefined ? (
                        <p className='clientName'>
                            {SelectedBrief.client !==null && SelectedBrief.client !==undefined ? (SelectedBrief.client.firstName || SelectedBrief.client.companyName) : ''} 
                            {SelectedBrief.client !==null && SelectedBrief.client !==undefined ? SelectedBrief.client.lastName : ''}
                        </p>
                    ) : (
                        <p className='clientName'>{SelectedBrief.client}</p>
                    )}
                    <p className='clientEmail'>{SelectedBrief?.client !==null && SelectedBrief.client !==undefined ? (SelectedBrief.client.website || SelectedBrief.client.email) : 'Not Assigned'}</p>
                </div>
            </div>
            <div className='JobNumberSection'>
                <p>Job Number- {SelectedBrief.referenceNumber !==null && SelectedBrief.referenceNumber !==undefined ? SelectedBrief.referenceNumber : ''}</p>
            </div>
        </div>
    );
};

export default ClientDetails;